import React from 'react';
import LoginContainer from '@src/containers/Login';

const Login = () => <LoginContainer />;

export default Login;
